import React, { useState } from 'react';
import { Settings, Volume2, VolumeX, Music, Music2, Gamepad2 } from 'lucide-react';
import { getAudioConfig, setAudioConfig, sfx } from './rpSounds';

const Barra = ({ valor, desligado, testid, onChange }) => (
  <input type="range" min="0" max="100" step="5" disabled={desligado} data-testid={testid}
    value={Math.round(valor * 100)} onChange={(e) => onChange(Number(e.target.value) / 100)}
    className={`mt-2 h-1.5 w-full cursor-pointer appearance-none rounded-full bg-purple-950 ${desligado ? 'opacity-30' : ''}`}
    style={{ accentColor: '#e879f9' }} />
);

// Engrenagem de áudio (mudo · sons do jogo · música) — mesmo controle dos outros eventos
export const RpAudioMenu = () => {
  const [aberto, setAberto] = useState(false);
  const [cfg, setCfg] = useState(getAudioConfig);
  const aplicar = (patch, bip = true) => { setCfg(setAudioConfig(patch)); if (bip) sfx.click(); };

  return (
    <div className="relative flex-none">
      <button onClick={() => { setAberto((v) => !v); sfx.click(); }} data-testid="rp-audio-gear" title="Som do evento"
        className={`flex h-8 w-8 items-center justify-center rounded-full border backdrop-blur transition-colors ${cfg.muted
          ? 'border-rose-500/70 bg-rose-950/50 text-rose-300' : 'border-fuchsia-400/60 bg-black/45 text-fuchsia-200 hover:border-lime-300/70 hover:text-lime-200'}`}>
        {cfg.muted ? <VolumeX className="h-4 w-4" /> : <Settings className="h-4 w-4" />}
      </button>
      {aberto && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setAberto(false)} />
          <div className="absolute right-0 top-10 z-50 w-56 space-y-2 rounded-2xl border border-fuchsia-500/50 bg-[#140a2e] p-2.5 shadow-[0_18px_40px_rgba(0,0,0,.8)]" data-testid="rp-audio-panel">
            <p className="text-[9px] font-black uppercase tracking-[0.22em] text-purple-300/70">som do evento</p>
            <button onClick={() => aplicar({ muted: !cfg.muted }, cfg.muted)} data-testid="rp-audio-mute"
              className={`flex w-full items-center justify-between rounded-xl border px-2.5 py-2 ${cfg.muted ? 'border-rose-600/70 bg-rose-950/50' : 'border-purple-700/60 bg-black/40'}`}>
              <span className="flex items-center gap-1.5 text-xs font-bold text-purple-100">
                {cfg.muted ? <VolumeX className="h-3.5 w-3.5 text-rose-400" /> : <Volume2 className="h-3.5 w-3.5 text-lime-400" />} Mudo
              </span>
              <span className={`text-[10px] font-black ${cfg.muted ? 'text-rose-300' : 'text-purple-400/70'}`}>{cfg.muted ? 'TUDO MUDO' : 'OFF'}</span>
            </button>
            <div className="rounded-xl border border-purple-700/60 bg-black/40 px-2.5 py-2">
              <button onClick={() => aplicar({ sfxOn: !cfg.sfxOn }, !cfg.sfxOn)} data-testid="rp-audio-sfx" className="flex w-full items-center justify-between">
                <span className="flex items-center gap-1.5 text-xs font-bold text-purple-100"><Gamepad2 className="h-3.5 w-3.5 text-amber-300" /> Sons do jogo</span>
                <span className={`text-[10px] font-black ${cfg.sfxOn && !cfg.muted ? 'text-lime-300' : 'text-purple-400/70'}`}>{cfg.sfxOn ? 'ON' : 'OFF'}</span>
              </button>
              <Barra valor={cfg.sfxVol} desligado={cfg.muted || !cfg.sfxOn} testid="rp-audio-sfx-vol" onChange={(v) => aplicar({ sfxVol: v })} />
            </div>
            <div className="rounded-xl border border-purple-700/60 bg-black/40 px-2.5 py-2">
              <button onClick={() => aplicar({ musicOn: !cfg.musicOn }, false)} data-testid="rp-audio-music" className="flex w-full items-center justify-between">
                <span className="flex items-center gap-1.5 text-xs font-bold text-purple-100">
                  {cfg.musicOn ? <Music className="h-3.5 w-3.5 text-amber-300" /> : <Music2 className="h-3.5 w-3.5 text-purple-500" />} Música
                </span>
                <span className={`text-[10px] font-black ${cfg.musicOn && !cfg.muted ? 'text-lime-300' : 'text-purple-400/70'}`}>{cfg.musicOn ? 'ON' : 'OFF'}</span>
              </button>
              <Barra valor={cfg.musicVol} desligado={cfg.muted || !cfg.musicOn} testid="rp-audio-music-vol" onChange={(v) => aplicar({ musicVol: v }, false)} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RpAudioMenu;
